export default __webpack_public_path__ + "static/media/grid5mobile.b6400216.png";